import { render } from "./AddTaxAddressModal.vue?vue&type=template&id=3ab62dd6&scoped=true"
import script from "./AddTaxAddressModal.vue?vue&type=script&lang=js"
export * from "./AddTaxAddressModal.vue?vue&type=script&lang=js"

import "./AddTaxAddressModal.vue?vue&type=style&index=0&id=3ab62dd6&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab62dd6"]])

export default __exports__